import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { MCPanelHeader } from './MCSection';
const LEVEL_COLOR = {
    DEBUG: 'var(--mc-text-meta-dim)',
    INFO: 'var(--mc-cyan)',
    WARN: 'var(--mc-amber)',
    ERROR: 'var(--mc-magenta)',
};
function formatTs(d) {
    const h = String(d.getHours()).padStart(2, '0');
    const m = String(d.getMinutes()).padStart(2, '0');
    const s = String(d.getSeconds()).padStart(2, '0');
    return `${h}:${m}:${s}`;
}
/**
 * Compact, scrolling operational event stream. Auto-scrolls to bottom on new
 * lines unless the user has scrolled up (then we hold position).
 */
export function MCLogTail({ lines, heading, levels, onLineClick }) {
    const scrollRef = useRef(null);
    const stickToBottomRef = useRef(true);
    const filtered = levels ? lines.filter((l) => levels.includes(l.level)) : lines;
    useEffect(() => {
        const el = scrollRef.current;
        if (!el || !stickToBottomRef.current)
            return;
        el.scrollTop = el.scrollHeight;
    }, [filtered.length]);
    const handleScroll = (e) => {
        const el = e.currentTarget;
        const distanceFromBottom = el.scrollHeight - (el.scrollTop + el.clientHeight);
        stickToBottomRef.current = distanceFromBottom < 24;
    };
    const counts = filtered.reduce((acc, l) => {
        acc[l.level] = (acc[l.level] || 0) + 1;
        return acc;
    }, {});
    return (_jsxs("div", { className: "flex flex-col h-full min-h-0", children: [_jsx(MCPanelHeader, { label: heading ?? '// OPS · EVENT STREAM', tight: true, className: "px-1", right: _jsx("div", { className: "flex items-center gap-2 mc-mono text-[10px] uppercase tracking-wider", children: ['ERROR', 'WARN', 'INFO'].map((lvl) => counts[lvl] ? (_jsxs("span", { style: { color: LEVEL_COLOR[lvl] }, children: [lvl[0], "\u00B7", counts[lvl]] }, lvl)) : null) }) }), _jsx("div", { ref: scrollRef, onScroll: handleScroll, className: "flex-1 min-h-0 overflow-y-auto mc-scroll-thin mc-mono text-[11px] leading-[1.45] px-1", children: filtered.length === 0 ? (_jsx("div", { className: "text-center py-6", style: { color: 'var(--mc-text-meta-dim)' }, children: "// awaiting events" })) : (filtered.map((line) => (_jsxs("button", { type: "button", onClick: () => onLineClick?.(line), disabled: !onLineClick, className: "mc-log-row flex gap-2 whitespace-nowrap w-full text-left px-1 -mx-1 rounded-sm transition-colors disabled:cursor-default", style: { background: 'transparent' }, onMouseEnter: (e) => {
                        if (onLineClick)
                            e.currentTarget.style.background = 'rgba(29,224,197,0.06)';
                    }, onMouseLeave: (e) => {
                        e.currentTarget.style.background = 'transparent';
                    }, children: [_jsx("span", { style: { color: 'var(--mc-text-meta-dim)' }, children: formatTs(line.ts) }), _jsx("span", { style: {
                                color: LEVEL_COLOR[line.level],
                                width: 38,
                                flexShrink: 0,
                            }, children: line.level }), _jsx("span", { style: {
                                color: 'var(--mc-text-meta)',
                                width: 64,
                                flexShrink: 0,
                            }, children: line.source }), _jsx("span", { className: "truncate", style: { color: 'var(--mc-text-primary)' }, title: line.message, children: line.message })] }, line.id)))) })] }));
}
